module.exports = __webpack_public_path__ + "static/media/Grzanie2.9fba5f88.svg";